import { cva, type VariantProps } from 'class-variance-authority'

export const cardVariants = cva('border border-line bg-surface rounded-lg', {
  variants: {
    padding: {
      sm: 'p-3',
      md: 'p-4',
      lg: 'p-6',
    },
  },
  defaultVariants: {
    padding: 'md',
  },
})

export type CardVariantProps = VariantProps<typeof cardVariants>
